// extracted by mini-css-extract-plugin
module.exports = {"scrollControl":"_2jt30","hidden":"_2JwVF","backTop":"ay5qr","up":"_1SP5v","down":"_26P_m"};